import React, {Component} from 'react';
import App from "../../App";
import {FiEye} from "react-icons/fi";
import  Pagination from 'react-js-pagination';
import {withRouter, Link} from "react-router-dom";
import "../../assets/scss/order-list.scss";
import {ToastsContainer, ToastsStore} from 'react-toasts';
import { getPaginatedList, getList } from "../../services/baseServices";
import {Button} from "react-bootstrap";

class List extends Component {
    constructor() {
        super();
        this.state = {
        routes: [],
        activePage: 1,
        per_page: 15,
        page: 1,
        query_params: {},
        };
    }

    getRouteList = (params) => {
		getPaginatedList("routes", params)
			.then((res) => {
				this.setState(
					{
						routes: res?.data?.data,
						isLoading: false,
						per_page: res.headers["x-per-page"],
						total_data: parseInt(res.headers["x-total"]),
					},
					() => {}
				);
			})
			.catch((errMsg) => {
				console.log("Error Message: ", errMsg);
			});
	};

    getQueryParams = () => {
		let params = Object.assign(this.state.query_params, {
			per_page: this.state.per_page,
			page: this.state.page,
		});
		return params;
	};

    componentDidMount() {
        this.getRouteList(this.getQueryParams());
    }

    handleOnSearch = (e) => {
		e.preventDefault();
		const tempParam = this.state.temp_params;
		this.setState({...this.state, page: 1, query_params: tempParam}, () => {
			this.getRouteList(this.state.temp_params);
		});
	}

	handleOnFieldChange = (e) => {
		const queryData = {...this.state.temp_params};
		queryData[e.target.name] = e.target.value;
		this.setState({temp_params: queryData}, () => {
		});
	}
    
    handlePageChange = (pageNumber) => {
		this.setState({ page: pageNumber, activePage: pageNumber }, () => {
			this.getRouteList(this.getQueryParams());
		});
	};

    handleOnClear = ()=>{
		this.setState({
			temp_params: {...this.state.temp_params, 
				title: '', 
				distributor_id:''
			},
			query_params: {...this.state.temp_params, 
				title: '', 
				distributor_id:''
			}
		}, () =>{
			this.getRouteList(this.getQueryParams());
		})
	}

    render() {
        return (
        <App layout="">
            <div className="main-content">

            <div className="page-header">
                <h2 className="page-title">SR List</h2>
            </div>
            <div align="center">
				<form className="form-inline mb-3">
					<div className="form-group mr-3">
						<label htmlFor="searchInput" className="sr-only">
							Router Name
						</label>
						<input
							type="search"
							name="title"
							id="title"
                            value={this.state.temp_params?.title}
							className="form-control form-control-sm"
							placeholder="Search by SR Name"
							onChange={this.handleOnFieldChange}
						/>
					</div>
					
					<Button
						size="sm"
						type={`submit`}
						onClick={this.handleOnSearch}
						variant="primary"
					>
						Filter
					</Button>
					<Button
						size="sm"
						type={`button`}
						className="ml-2"
						onClick={this.handleOnClear}
						variant="danger"
					>
						Clear
					</Button>
				</form>
			</div>
            <div className="card-block">
                <div className="block-body">
                <table className="order-table table table-striped">
                    <thead>
                    <tr>
                    <th style={{width: '20px'}}>#</th>
                    <th>Route Name</th>
                    <th>DIstributor</th>
                    <th>Phone</th>
                    <th>Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.state.routes.length > 0 ? this.state.routes.map((item, index) => {
                    return (
                        <tr key={1}>
                        <td>{((this.state.page - 1) * this.state.per_page) + index + 1}</td>
                        <td>
                            <div className="order-item">
                            {item?.title}
                            </div>
                        </td>
                        <td>
                            <div className="order-item">
                            {item?.distributor_name}
                            </div>
                        </td>
                        <td>
                            <div className="order-item">
                            {item?.phone}
                            </div>
                        </td>
                        <td style={{width: '150px'}}>
                            <Link to={`/srMargin/details/${item.id}`} className="btn btn-sm btn-default"><FiEye/></Link>
                        </td>
                        </tr>
                    );
                    }) : ""}
                    </tbody>
                </table>
                </div>
                <div className="mt-3">
                <Pagination
                    itemClass="page-item"
                    linkClass="page-link"
                    activePage={this.state.activePage}
                    itemsCountPerPage={this.state.per_page}
                    totalItemsCount={this.state.total_data}
                    pageRangeDisplayed={10}
                    onChange={this.handlePageChange.bind(this)}
                />
                </div>
            </div>
            </div>
            <ToastsContainer store={ToastsStore}/>
        </App>
        );
    }
    }

export default withRouter(List);
